module.exports = __webpack_public_path__ + "assets/img/对比分析.218359d7.png";